var render, staticRenderFns
import script from "./VPopup.vue?vue&type=script&lang=ts&"
export * from "./VPopup.vue?vue&type=script&lang=ts&"
import style0 from "./VPopup.vue?vue&type=style&index=0&id=4bc0aa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0aa22",
  null
  
)

export default component.exports